//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import ItemId from '@models/ItemId';
import { UniversalItemType } from '@models/UniversalItemType';
import { isBulkSelected } from '@utils/networkItemUtils';

import { getBulkActionsSelectedItems } from 'app/bulk-actions/selectors/bulk-actions-selector';

export const useGetIsBulkSelected = (
  itemType?: UniversalItemType,
  id?: ItemId,
) => {
  const selectedItems = useSelector(getBulkActionsSelectedItems);
  return useMemo(() => {
    if (itemType && id) {
      return isBulkSelected(selectedItems, itemType, id);
    } else {
      return false;
    }
  }, [selectedItems, itemType, id]);
};

export const useGetIsAnyItemBulkSelected = () => {
  return useSelector(getBulkActionsSelectedItems).length > 0;
};
